import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDCBJVI0eX1Je9PAdYZ9QHzk2DQUk6c5C8",
  authDomain: "habit-centred-todolist.firebaseapp.com",
  projectId: "habit-centred-todolist",
  storageBucket: "habit-centred-todolist.firebasestorage.app",
  messagingSenderId: "95808292560",
  appId: "1:95808292560:web:44874fa3bb9f6ebc8d40d5",
  measurementId: "G-S2J4Y7BD4V"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);